import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function BusinessSection() {
  const checkoutUrl = 'https://magiadigital.online/checkouts/cn/hWN9TYd7nIHOv98RJ6pjImQM/es-ar?_r=AQABPAMwqwcFHsaNx77xI9-vQVNjUUJUKqqMcQTwOKcBl4s&preview_theme_id=158917099778';
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const benefits = ['Producto digital (sin envíos)', 'Sin stock', 'Puedes vender en Instagram o WhatsApp', 'Descarga inmediata'];
  return <section className="w-full bg-pink-50 py-20 sm:py-28" data-id="element-40">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" ref={ref} data-id="element-41">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-42">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-slate-900 mb-6" data-id="element-43">
            💰 Empieza un negocio digital con decoraciones imprimibles
          </h2>
          <p className="text-xl text-slate-600 mb-4" data-id="element-44">
            Muchas mamás están vendiendo kits de cumpleaños desde casa.
          </p>
          <p className="text-xl font-bold text-rose-500" data-id="element-45">
            Este pack te da todo listo para empezar.
          </p>
        </motion.div>

        <motion.div className="bg-white rounded-3xl shadow-xl p-8 sm:p-12 border border-rose-100 relative overflow-hidden" initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-46">
          {/* Decorative background element */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-rose-100 to-pink-50 rounded-full opacity-50 -translate-y-1/2 translate-x-1/2 pointer-events-none" data-id="element-47" />

          <h3 className="text-2xl font-bold text-slate-900 mb-8 relative z-10" data-id="element-48">
            Beneficios:
          </h3>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10 relative z-10" data-id="element-49">
            {benefits.map((benefit, i) => <motion.div key={i} className="flex items-start gap-4 bg-pink-50/50 p-4 rounded-xl" initial={{
            opacity: 0,
            x: -20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            duration: 0.4,
            delay: 0.3 + i * 0.1
          }} data-id="element-50">
                <div className="flex-shrink-0 w-8 h-8 bg-rose-500 rounded-full flex items-center justify-center mt-0.5 shadow-sm" data-id="element-51">
                  <CheckIcon className="w-5 h-5 text-white" data-id="element-52" />
                </div>
                <span className="text-slate-700 font-semibold text-lg" data-id="element-53">
                  {benefit}
                </span>
              </motion.div>)}
          </div>

          <motion.div className="bg-gradient-to-r from-amber-400 to-amber-500 rounded-2xl p-6 text-center shadow-lg mb-10 relative z-10" initial={{
          opacity: 0,
          scale: 0.95
        }} animate={isInView ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          duration: 0.5,
          delay: 0.7
        }} data-id="element-54">
            <p className="text-white font-extrabold text-xl sm:text-2xl" data-id="element-55">
              💡 Un solo archivo puede venderse muchas veces.
            </p>
          </motion.div>

          <div className="text-center relative z-10" data-id="element-56">
            <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="shimmer-btn inline-flex items-center justify-center px-10 py-5 bg-gradient-to-r from-rose-500 to-pink-500 text-white text-xl font-bold rounded-2xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 w-full sm:w-auto" data-id="element-57">
              👉 Empezar mi Negocio — $27.990 ARS
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}